import { STORES_ACTIONS } from "./actions";

export interface IMainPage {
  isPending: boolean;
  isError: boolean;
  errorMessage: string;
  stores: any[];
}

const initialState: IMainPage = {
  isPending: false,
  isError: false,
  errorMessage: "",
  stores: [],
};

export const storesReducer = (state: IMainPage = initialState, action): IMainPage => {
  switch (action.type) {
    case STORES_ACTIONS.FETCH_STORES_SUCCESS: {
      return {
        isError: false,
        isPending: false,
        errorMessage: "",
        stores: action.payload,
      };
    }
    default:
      return state;
  }
};
